import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {EducationObservationService} from "../../educationObservation/education-observation.service";
import {LogService} from "../../../../../services/log.service";
import {Router} from "@angular/router";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {EducationInduction} from "../induction.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {CentreOption, EducationObservation} from "../../educationObservation/education-observation.model";
import {InductionService} from "../induction.service";
import {AddEditInductionComponent} from "../add-edit-induction/add-edit-induction.component";
import {MatDialog} from "@angular/material/dialog";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {FormControl} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {SpecialDay} from "../../special-day/special-day.model";
import {MatSelectChange} from "@angular/material/select";
import {EmployeeService} from "../../../../../services/employee.service";
import {CentreService} from "../../../../../services/centre.service";
import { Timestamp } from 'firebase/firestore';
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
  selector: 'app-induction-list',
  templateUrl: './induction-list.component.html',
  styleUrls: ['./induction-list.component.scss']
})
export class InductionListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  displayedColumns: string[] = [
    'srNo',
    'inductionFor',
    'inductionCentreName',
    'createdAt',
    'actions'
  ];

  dataSource = new MatTableDataSource<EducationInduction>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  startDate = new FormControl<Date | null>(null);
  endDate = new FormControl<Date | null>(null);
  teachers$!: Observable<any[]>
  SelectCentre = new FormControl('')
  centres$!: Observable<CentreOption[]>;
  selectedCentre: string | null = null;
  isLoading = false;
  mTeacher: string | null = null
  allEducationInduction: EducationInduction[] = [];

  constructor(
    private educationService: InductionService,
    private mLogService : LogService,
    private router: Router,
    private dialog: MatDialog,
    private readonly mEmployeeService: EmployeeService,
    private readonly centreService: CentreService,
    private readonly financialYearService: FinancialYearService,
  ) {
    this.teachers$ = this.mEmployeeService.getTeachers()
    this.centres$ = centreService.getAllCentres()
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);
    this.loadList();
  }

  loadList() {
    this.educationService.getAll().pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
      this.dataSource.data = data;
      console.log(data);
      this.allEducationInduction = data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
  downloadExcel(): void {
    const data = this.dataSource?.filteredData || [];

    if (!data.length) {
      alert("No Data Available");
      return;
    }

    const exportData = data.map((row: any, index: number) => ({
      'Sr No': index + 1,
      'Teacher': row.teacherName || '',
      'Centre': row.centreName || '',
      'Created At': row.createdAt ? new Date(row.createdAt.toDate()).toLocaleDateString('en-GB') : '',  // dd/mm/yyyy format
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Education Induction': worksheet },
      SheetNames: ['Education Induction']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveAsExcelFile(excelBuffer, 'Education_Induction_List');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }

  onCentreChange(event: MatSelectChange) {
    this.selectedCentre = event.value;
  }

  search() {
    this.isLoading = true;

    const centre = this.selectedCentre || this.SelectCentre.value || 'All';
    console.log(centre)
    const teacher = this.mTeacher || 'All';

    const from = this.startDate.value
      ? new Date(new Date(this.startDate.value).setHours(0, 0, 0, 0))
      : null;

    const to = this.endDate.value
      ? new Date(new Date(this.endDate.value).setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allEducationInduction];
    console.log(filtered)

    if (centre !== 'All') {
      filtered = filtered.filter((item:any) => item.inductionCentreCode === centre);
    }


    if (from && to) {
      filtered = filtered.filter(item => {
        const itemDate =
          item.createdAt instanceof Timestamp
            ? item.createdAt.toDate()
            : null;
        return itemDate && itemDate >= from && itemDate <= to;
      });
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();

    this.isLoading = false;
  }

  clearAll() {
    this.selectedCentre = 'All';
    this.SelectCentre.setValue('All');
    this.mTeacher = 'All';
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);

    this.dataSource.data = this.allEducationInduction;
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();
  }

  applyFilter(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    this.dataSource.filter = input.value.trim().toLowerCase();
  }

  // addInduction() {
  //   this.router.navigate(['/home/education/add-induction']);
  // }
  addInduction() {
    const dialogRef = this.dialog.open(AddEditInductionComponent, {
      width: '1000px',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
      data: null
    });
  }

  // edit(row: EducationInduction) {
  //   this.router.navigate(['/home/education/edit-induction', row.id]);
  // }
  edit(row: EducationInduction) {
    const dialogRef = this.dialog.open(AddEditInductionComponent, {
      width: '1000px',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
      data: row.id
    });
  }


  view(row: any) {
    // ✅ Add activity log before navigation
    const activity = {
      date: new Date().getTime(),
      section: 'Education Induction',
      action: 'Viewed',
      description: `Education Induction viewed by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    // ✅ Navigate to view page
    this.router.navigate(['/home/education/induction-view', row.id]);
  }



  delete(id: string | undefined) {
    if (!id) return;

    if (confirm('Are you sure to delete this Induction?')) {
      this.educationService.deleteRow(id)
        .then(() => {
          alert('Induction deleted successfully');

          // ✅ Add activity log
          const activity = {
            date: new Date().getTime(),
            section: 'Education Induction',
            action: 'Deleted',
            description: `Education Induction deleted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);
        })
        .catch((error) => {
          console.error('Error deleting Induction:', error);
          alert('Error deleting Induction!');
        });
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;

}
